/* eslint-disable react/no-unknown-property */
import { FC } from 'react';

export const CheckedIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" data-testid="checked-icon">
    <path d="M13.3333 4L5.99996 11.3333L2.66663 8" stroke="#195AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
